import { useEffect, useState, lazy, Suspense } from 'react';

const API = import.meta.env.VITE_API_URL;

// Lazy-loaded so @xyflow/react (and its CSS) only download when this tab is opened.
const MyNetworkChart = lazy(() => import('./MyNetworkChart'));

export default function Tree() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [tree, setTree] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/affiliate-portal/tree`, { credentials: 'include' })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((r) => r.json() as Promise<{ success: boolean; data: any }>)
      .then((j) => {
        if (j.success) setTree(j.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">My Network</h2>
      <p className="text-sm text-slate-600 dark:text-slate-300 mb-6">
        Visualizes the customers you've referred and any other affiliates you've brought in. Override commissions are
        earned when you refer other affiliates who also bring in customers.
      </p>

      {loading ? (
        <div className="text-center text-slate-500 dark:text-slate-400 py-8">Loading...</div>
      ) : !tree?.root ? (
        <div className="text-center text-slate-500 dark:text-slate-400 py-8">No network data.</div>
      ) : (tree.direct_locations?.length || 0) === 0 && (tree.direct_downlines?.length || 0) === 0 ? (
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-lg shadow-sm p-8 text-center text-slate-500 dark:text-slate-400">
          No referrals yet. Share your referral code (see the Referral Link page) to start building your network.
        </div>
      ) : (
        <>
          <Suspense
            fallback={<div className="text-center text-slate-500 dark:text-slate-400 py-8">Loading chart…</div>}
          >
            <MyNetworkChart tree={tree} />
          </Suspense>

          <div className="mt-3 text-xs text-slate-500 dark:text-slate-400 flex flex-wrap items-center gap-x-4 gap-y-1">
            <strong>Legend:</strong>
            <span className="inline-flex items-center gap-1"><span className="w-3 h-3 bg-blue-500 rounded"></span> You</span>
            <span className="inline-flex items-center gap-1"><span className="w-3 h-3 bg-green-500 rounded"></span> Customer — active plan</span>
            <span className="inline-flex items-center gap-1"><span className="w-3 h-3 bg-amber-400 rounded"></span> Past-due plan</span>
            <span className="inline-flex items-center gap-1"><span className="w-3 h-3 bg-slate-400 rounded"></span> No plan</span>
            <span className="inline-flex items-center gap-1"><span className="w-3 h-3 bg-purple-500 rounded"></span> Affiliate you brought in</span>
          </div>
          <p className="mt-2 text-xs text-slate-400 dark:text-slate-500">
            Customers referred by affiliates you brought in are shown anonymized.
          </p>
        </>
      )}
    </div>
  );
}
